/* globals Drupal */

import React from 'react';
import PropTypes from 'prop-types';

const UserInfo = ({ fullName, editUrl, logoutUrl }) => (
    <div className="user-info">
        <div className="user-info__content">
            {Drupal.t('Logged in as')}
            <p className="user-info__name">{fullName}</p>
        </div>
        <div className="buttons">
            <a className="button button--normal button--light-bg" href={editUrl}>
                {Drupal.t('My profile')}
            </a>
            <a className="button button--normal button--light-bg" href={logoutUrl}>
                {Drupal.t('Log out')}
            </a>
        </div>
    </div>
);

UserInfo.propTypes = {
    fullName: PropTypes.string.isRequired,
    editUrl: PropTypes.string.isRequired,
    logoutUrl: PropTypes.string.isRequired,
};

export default UserInfo;
